import { Component, OnInit, OnDestroy, EventEmitter, ViewContainerRef, ViewEncapsulation, Output, Input, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OptionsserviceService, UserService, CustomerService, AuthenticationService, StorageService, LoansService, DataService } from '../../_services/index'; 

@Component({
  selector: 'app-investmentstatement',
  templateUrl: './investmentstatement.component.html',
  styleUrls: ['./investmentstatement.component.css']
})
export class InvestmentstatementComponent implements OnInit {

  @Input('parentRouteId') parentRouteId:any;
  @Input('sub_summary') sub_summary = '0';
  currentUser: any;
  public sub: any;
  data: any;
  data_:any;
  statement_type = 0;
  constructor(public optionsService: OptionsserviceService, public router: Router, public route: ActivatedRoute, 
    public loansService: LoansService, public customerService: CustomerService, public userService: UserService, 
    public storageService: StorageService, private dataService: DataService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    //this.parentRouteId = route.snapshot.parent.params['id'];
  }
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {  
      let change = changes[propName];
      
      let curVal  = JSON.stringify(change.currentValue);
      let prevVal = JSON.stringify(change.previousValue);
      //let changeLog = `${propName}: currentValue = ${curVal}, previousValue = ${prevVal}`;
      
      if (propName === 'parentRouteId') {
         this.data = this.data_;
         this.getApp();
      }  
    }
  }
  ngOnInit() {
    this.getApp()

  }
  getApp() {
    this.loansService.getInvStatement(this.currentUser.token, this.parentRouteId, this.statement_type)
      .subscribe(data => {
        this.dataService.investmentHasLoaded.emit({});
        this.data = data;
      });
  }
  break_loan(){
    
  }
}
